import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import Icon from './Icon';
import './Toggle.css';

export default function Toggle() {
  const { isDark, toggleTheme } = useTheme();

  return (
    <div className={`theme-seg ${isDark ? 'theme-seg--dark' : 'theme-seg--light'}`} role="group" aria-label="Color theme">
      <span className="theme-seg__thumb" aria-hidden="true" />
      <button
        className={`theme-seg__btn theme-seg__btn--light ${!isDark ? 'theme-seg__btn--active' : ''}`}
        onClick={toggleTheme}
        type="button"
        aria-pressed={!isDark}
        aria-label="Toggle theme"
      >
        <Icon name="sun" size={13} />
      </button>
      <button
        className={`theme-seg__btn theme-seg__btn--dark ${isDark ? 'theme-seg__btn--active' : ''}`}
        onClick={toggleTheme}
        type="button"
        aria-pressed={isDark}
        aria-label="Toggle theme"
      >
        <Icon name="moon" size={13} />
      </button>
    </div>
  );
}
